import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Components
import Footer from "../../components/Footer/Footer"
import Navbar from "../../components/Navbar/Navbar"
import Newsletter from "../../components/Newsletter/Newsletter"
import Products from "../../components/Products/Products"
import HeroImage from "../../components/HeroImage/HeroImage"
import Filter from "../../components/Filter/Filter"
// Data
import { categories } from "../../data"
// Styles
import { Container, Wrapper, Title, TitleWrapper } from "./ProductsList.styles"
import { ExpandMoreOutlined, ExpandLessOutlined } from "@mui/icons-material"

const ProductsList = () => {
   const location = useLocation()
   const { t } = useTranslation()
   const categoryName = location.pathname.split("/")[2]
   const category = categories.find((item) => item.category === categoryName)

   const [filters, setFilters] = useState({
      mainColor: "all",
      secondColor: "all",
      size: "all",
      gender: "all",
   })
   const [sorts, setSorts] = useState("latest")
   const [endingPoint, setEndingPoint] = useState({ top: 0, left: 0 })
   const [bgImageColor, setBgImageColor] = useState("dark")
   const [displayFilter, setDisplayFilter] = useState(false)

   const toggleFilter = (e) => {
      e.preventDefault()
      setDisplayFilter((prev) => !prev)
   }

   useEffect(() => {
      window.scrollTo(0, 0)
   }, [])

   useEffect(() => {
      const screenHeight = window.innerHeight
      const handleScroll = () => {
         if (window.scrollY > screenHeight * 0.6) {
            setBgImageColor("light")
         } else {
            setBgImageColor("dark")
         }
      }

      window.addEventListener("scroll", handleScroll)
      return () => window.removeEventListener("scroll", handleScroll)
   }, [])

   return (
      <>
         <Helmet>
            <title>{t("productsPage.meta.meta_title")}</title>
            <meta
               name="description"
               content={t("productsPage.meta.meta_description")}
            />
         </Helmet>
         <Container>
            <Navbar
               getCartPosition
               setCartPosition={setEndingPoint}
               bgImageColor={bgImageColor}
            />
            <Wrapper>
               <HeroImage
                  imageHeight={"60vh"}
                  imageNumber={category ? category.id : 0}
               />
               <TitleWrapper onClick={toggleFilter}>
                  <Title>{t("productsPage.label.l1")}</Title>
                  {displayFilter ? (
                     <ExpandLessOutlined color="text" fontSize="large" />
                  ) : (
                     <ExpandMoreOutlined color="text" fontSize="large" />
                  )}
               </TitleWrapper>
               {displayFilter ? (
                  <Filter
                     categoryName={categoryName}
                     filters={filters}
                     setFilters={setFilters}
                     setSorts={setSorts}
                  />
               ) : (
                  <></>
               )}
               <Products
                  category={category?.category}
                  filters={filters}
                  sort={sorts}
                  endingPoint={endingPoint}
               />
            </Wrapper>
            <Newsletter />
            <Footer />
         </Container>
      </>
   )
}

export default ProductsList
